<template>
	<div class="register">
		<van-nav-bar
		  	:title="$t('ForgetPassword.title')"
		  	left-arrow
			  fixed
		  	@click-left="$router.go(-1)">
			<van-icon name="arrow-left" slot="left" style="font-size: 20px;color: #000;"/>
		</van-nav-bar>
		<van-cell-group>
			<van-field
			  	readonly
			  	clickable
			  	left-icon="static/img/Area_code.png"
			  	right-icon="arrow"
			  	:value="areaName"
			  	:placeholder="$t('ForgetPassword.areaName')"
			  	@click="showPicker = true"
			/>
		</van-cell-group>
		<van-popup v-model="showPicker" position="bottom">
			<van-icon
				slot="right-icon"
				name="./static/img/ok1.png"
				size="25px"
				@click="add()"
			/>
		  	<van-picker
			    show-toolbar
			    :columns="columns"
			    :confirm-button-text="$t('vantText.confirm')"
				:cancel-button-text="$t('vantText.cancel')"
			    @cancel="showPicker = false"
			    @confirm="onConfirm"
		  	/>
		</van-popup>
		<van-cell-group>
			<van-field
			    v-model="phone"
			    left-icon="static/img/iphone_num.png"
			    right-icon=""
			    clearable
			    :placeholder="$t('ForgetPassword.inputPhone')"
				/>
				<span class="SMSconfirm" @click='sendCode()'>{{$t('ForgetPassword.SMS')}}</span>
		</van-cell-group>
		<van-cell-group>
		  	<van-field
			    v-model="smscode"
			    left-icon="static/img/Verification.png"
			    center
			    clearable
			    :placeholder="$t('ForgetPassword.inputSMS')"
		  	>
  			</van-field>
		</van-cell-group>
		<van-cell-group>
			<van-field
			    v-model="password"
			    type="password"
			    left-icon="static/img/Password.png"
			    clearable
			    @input="judgePassword()"
			    :placeholder="$t('ForgetPassword.setNewPassword')"
				/>
		</van-cell-group>
		<van-cell-group>
			<van-field
			    v-model="repassword"
			    type="password"
			    clearable
			    left-icon="static/img/Password.png"
			    :placeholder="$t('ForgetPassword.certainPassword')"
			    @input="judgePassword()"
			    :error-message='repasswordJudge'
				/>
		</van-cell-group>
		<div class="btnWrap">
			<van-button round class="smsBtn regBtn" size="large" type="primary" @click="forget()">{{$t('ForgetPassword.submit')}}</van-button>
		</div>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		areaName:'',
      		areacode:'',
      		showPicker: false,
      		columns: [],
      		phone:'',
      		smscode:'',
      		password:'',
      		repassword:'',
      		isSms:false,
      		smskey:'',
			repasswordJudge:'',
			getLangs:''
      	}
    },
    mounted:function(){
		this.getAreacode();
		this.getLangs = this.$i18n.locale;
    },
    methods:{
    	onConfirm(value,index) {
	      	this.areacode = this.columns[index].acnumber;
	      	this.areaName =value.text;
	      	this.showPicker = false;
    	},
    	getAreacode(){
    		this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/areacode',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.columns=res.data.data;
                	for(var i = 0;i<this.columns.length;i++){
                		if(this.getLangs=='en'){
							this.columns[i].text=this.columns[i].acname_en+'('+this.columns[i].acnumber+')';
						}else if(this.getLangs=='hk'){
							this.columns[i].text=this.columns[i].acname_hk+'('+this.columns[i].acnumber+')';
						}else if(this.getLangs=='zh'){
							this.columns[i].text=this.columns[i].acname_cn+'('+this.columns[i].acnumber+')';
						}else{
							this.columns[i].text=this.columns[i].acname_en+'('+this.columns[i].acnumber+')';
						}
                	}
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('ForgetPassword.message'),
        		});
            });
		},
		sendCode(){
			if(this.areacode&&this.phone){
				this.$axios({
	                method: 'post',
	                url: this.$build+'/api/send',
	                data:{
	                	area_code:this.areacode,
	                	phone:this.phone,
	                },
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});           	
		            	this.isSms=true;
		            	this.smskey=res.data.success.key;
		            	const vm=this;
		            	setTimeout(function(){
		            		vm.isSms=false;
		            		console.log(1111111);
		            	},60000);
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('ForgetPassword.message'),
            		});
	            });
			}else{
				this.$toast(this.$t('ForgetPassword.inputAreaNameAndPhone'));
			}
		},
		forget(){
			if(!this.smskey){
				this.$toast(this.$t('ForgetPassword.getSMSkey'));
				return;
			}
			if(this.password&&this.repassword&&this.phone&&this.smscode){
				this.$axios({
	                method: 'post',
	                url: this.$build+'/api/user/forgot',
	                data:{
	                	key:this.smskey,
	                	code:this.smscode,
	                	password:this.password,
	                	comfirmPassword:this.repassword,
	                },
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	const vm=this;
		            	setTimeout(function(){
	            			vm.$router.push('/');
		            	},1500);           	
	            	}else{
	            		this.$toast.allowMultiple();
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('ForgetPassword.message'),
            		});
	            });
			}else{
				this.$toast(this.$t('ForgetPassword.toast'));
			}
		},
		judgePassword(){
			if(this.password==this.repassword){
				this.repasswordJudge='';
			}else{
				this.repasswordJudge=this.$t('ForgetPassword.repasswordJudge');
			}
		}
    }
}
</script>
<style scoped>
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color:#2f75f7;
	}
	.van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	.van-field .van-icon{
		font-size: 20px;
	}
	.register{
		width: 100%;
		height: 100vh;
	}
	.smsBtn{
		background:#000;
		color: #fff;
		font-weight: bold;
		border: none;
	}
	.regBtn{
		width: 90%;
		height: 40px;
		line-height: 40px;
		margin-left: 5%;
		margin-top: 10px;
	}
	.btnWrap{
		margin-top: 15px;
		width: 100%;
		height: 60px;
	}
	.van-cell{
		position: relative;
	}
	.SMSconfirm{
		position: absolute;
		z-index: 1;
		top: 7px;
		right: 15px;
		color: #fff;
		background: #2f75f4;
		font-size: 16px;
		border-radius: 13px;
		padding: 3px;
	}
</style>





// WEBPACK FOOTER //
// src/components/ForgetPassword.vue